// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationBanner-cls1_E7l","cls2":"ConfirmationBanner-cls2_Xo5 ConfirmationBanner-cls1_E7l"};